export default __webpack_public_path__ + "static/media/help-bg.e064f950.png";